import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Tabs } from "antd";
import AllActivity from "./AllActivity";
const { TabPane } = Tabs;

const ActivityLog = () => {
  return (
    <div className="main-box">
      <Sidebar activeId={5} />
      <main className="main-content">
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <Header title="Activity Log" />
          <div style={{ flex: 1, backgroundColor: "#FAFAFB" }}>
            <div className="tab-container" style={{ width: "90%" }}>
              <Tabs
                defaultActiveKey="1"
                style={{ width: "100%", height: "100%" }}
              >
                <TabPane tab="All Activity" key="1">
                  <AllActivity />
                </TabPane>
                {/* <TabPane tab="Error Report" key="2">
                  <div>Hello</div>
                </TabPane> */}
              </Tabs>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ActivityLog;
